import React, { useEffect } from "react";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import { ExpandMore, Check, Close } from "@material-ui/icons";
import useStyles from "../styles";
import { useRecoilValue } from "recoil";
import { useTranslation } from "react-i18next";
import {
  metaDataDetails,
  // permissionsSet
} from "Recoil/LoggedInUserDetail/selector";
import { get, isEmpty } from "lodash";
import { Controller, useFormContext } from "react-hook-form";
import TargetToggle from "./TargetToggle";
import CheckboxWithoutLabel from "Components/formControls/CheckboxWithoutLabel";
import InputField from "Components/formControls/HookFields/InputFieldWithText";
import { useOrganizationValidation } from "Validations/Organization/useOrganizationValidation";
import { checkArrayLength } from "src/utils";
import ErrorValidation from "Components/ErrorValidation";

const Target = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const {
    register,
    watch,
    setValue,
    setError,
    control,
    clearErrors,
    formState: { errors }
  } = useFormContext();
  const { features, disabledView } = watch();
  const { organizationTargetError, organizationTargetTypeError } =
    useOrganizationValidation();
  const name = "features.target";
  const { target } = useRecoilValue(metaDataDetails);
  // const permissions = useRecoilValue(permissionsSet);
  // const targetManagement = get(permissions, "targetManagement", {});
  // const condition =
  //   get(targetManagement, "readAccess", false) ||
  //   get(targetManagement, "deleteAccess", false) ||
  //   get(targetManagement, "writeAccess", false) ||
  //   get(targetManagement, "modifyAccess", false);
  useEffect(() => {
    if (!checkArrayLength(features?.target) && checkArrayLength(target)) {
      const targetValue = target.map(res => {
        const obj = JSON.parse(res.value);
        return {
          type: res.name,
          name: obj.target,
          color: obj.color,
          isEnabled: true
        };
      });
      setValue(name, targetValue);
    }
  }, [checkArrayLength(features?.target), checkArrayLength(target)]);

  const onCheckBoxChange = (e, i) => {
    const { checked } = get(e, "target");
    setValue(`${name}.${i}.isEnabled`, checked);
  };

  return (
    <Box>
      <Accordion data-testid="accord" className={classes.accordion}>
        <AccordionSummary
          expandIcon={<ExpandMore />}
          aria-controls="panel1a-content"
          id="panel1a-header"
          className={classes.accordionSummary}>
          <Typography className={classes.heading}>
            {t("Target features")}
          </Typography>
        </AccordionSummary>
        <AccordionDetails className={classes.accordionDetails}>
          <Box display="flex" my={2}>
            <Box className={classes.targetWrapper} p={3} mr={1.5}>
              <Box mb={2}>
                <Typography className={classes.heading}>
                  {t("Target type")}
                </Typography>
              </Box>
              {get(features, "target", []).map((target, i) => (
                <Box>
                  {disabledView ? (
                    <ul className={classes.qusList}>
                      <li>
                        <span>
                          {target.isEnabled ? <Check fontSize="small" className={classes.checkIcon} /> : <Close fontSize="small" className={classes.crossIcon} />}
                        </span>
                        <span className={target.isEnabled ? "" : classes.crossIcon}>{target.name}</span>
                      </li>
                    </ul>
                  ) : <Box
                    display={"flex"}
                    justifyContent="space-between"
                    mb={1}
                    alignItems="flex-start">
                    <CheckboxWithoutLabel
                      register={register(`${name}.${i}.isEnabled`)}
                      checked={target.isEnabled}
                      name={`${name}.${i}.isEnabled`}
                      data-testid="btn"
                      onChange={e => onCheckBoxChange(e, i)}
                    // disabled={disabledView}
                    />
                    <Controller
                      name={`${name}.${i}.name`}
                      register={register(
                        `${name}.${i}.name`,
                        organizationTargetTypeError
                      )}
                      control={control}
                      render={({ field }) => {
                        const { onChange } = field;
                        return (
                          <InputField
                            onChange={e => {
                              const existing = get(features, "target", []).find(
                                res => res.name == e.target.value
                              );
                              if (!isEmpty(existing)) {
                                setError(
                                  "features.target",
                                  organizationTargetError
                                );
                              } else {
                                clearErrors("features.target");
                              }
                              onChange(e);
                            }}
                            error={get(errors, `${name}.${i}.name.message`, "")}
                            value={target.name}
                          // disabled={!condition || disabledView}
                          />
                        );
                      }}
                    />
                  </Box>}
                </Box>
              ))}
              {get(errors, "features.target.message") ? (
                <ErrorValidation
                  error={get(errors, "features.target.message")}
                />
              ) : null}
            </Box>
            <Box className={classes.targetWrapper} p={3} ml={1.5}>
              <Typography className={classes.heading}>
                Target details
              </Typography>
              <TargetToggle />
            </Box>
          </Box>
        </AccordionDetails>
      </Accordion>
    </Box>
  );
};
export default Target;
